import React, { useEffect , useState } from 'react'
import { Link } from 'react-router-dom'
import Skeleton from '../skelton'

const LatestList = () => {
 
 
          const [latest,setLatest] = useState(null)
          const [loading,setLoading] = useState(true)
          const [error,setError] = useState(null)

    
    useEffect(() => {
         
          
         const fetchData = async () => {
      try {
        const res = await fetch("https://teluguone.com/photos_api/photosLatestJson?start=0&limit=6");
        if (!res.ok) throw new Error(`API Response Was Not Ok`)
        const data = await res.json();
        setLatest(data.photosHomeByType || '');
      
      } catch (e) {
        console.error("Fetch error:", e);
        setError(e.message)
      }finally {
         setLoading(false)
      }
    };

    fetchData();
         

    },[])  
    
    
  


    if (loading) {
        return  <ul className="latest-list">
              {[0,0,0,0,0,0].map((item,index) => <li key={index}>
              <Link key={index} to="" >
                <Skeleton type="latest-list-img" />
                <div>
                  <h4>latest</h4>
                  <span>See More...</span>
                </div>
              </Link>
            </li>  ) }
        </ul>
    }
    if (error) {
        return null;
    }




   
    return (
     
         <ul className="latest-list">
          
          
           {latest && latest.map((item,index) => <li key={index}>
              <Link key={index} to={(item.url_link  ? item.url_link.substring(item.url_link.indexOf('/photos')+7) :""  )} >
                <img src={item.stimg || ""} alt={item.title || ''} loading={index === 0 ? 'auto' : 'lazy'} />
                <div>
                  <h4>{item.title || ''}</h4>
                  <span>See More...</span>
                </div>
              </Link>
            </li>  ) }
          
          </ul>
  )


}

export default LatestList
